import { Component, Input } from '@angular/core';
import { IconStyle } from '@wdx/shared/utils';
import { CommentStatus } from '../../../models/comment-status.model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'atom-comment-status',
    templateUrl: './atom-comment-status.component.html',
    standalone: false,
})
export class AtomCommentStatusComponent {
    @Input() commentStatus: CommentStatus;
    @Input() longFormat: boolean;

    readonly ICON_STYLE = IconStyle;
}
